import { BehaviorSubject } from "rxjs"
import Http from './http/engrais'
import { ListItemInterface } from "../useApp";
import Idb from "../__api_v2/_Idb"

export interface EngraisInterface {
    id: string;
    name: string;
    imageId: string | null;
    type: string;
    composition: { K: number | null, N: number | null, P: number | null };
    modesUsage: ListItemInterface[];
    momentsUsage: ListItemInterface[];
    ensoleil: string;
}

export const Engraiss$ = new BehaviorSubject<EngraisInterface[]>([])
export const Engrais$ = new BehaviorSubject<EngraisInterface | null>(null)

export default class ApiEngrais {
    private _idb!: Idb<'engrais'>
    private _http!: Http
    React: any;
    constructor() {
        this._idb = new Idb('engrais')
        this._http = new Http()
    }

    getAll = (): void => {
        this._idb.getAll().then(data => Engraiss$.next(data)).then(() =>
            this._http.getAll().then(resp => {
                if (resp.status === 200) {
                    resp.json().then((json: EngraisInterface[]) => {
                        return this._idb.posts(json)
                    }).then(() => this._idb.getAll().then(data => Engraiss$.next(data)))
                }
            }))
    }

    get = (id: EngraisInterface['id']): void => {
        this._idb.get(id).then(data => data && Engrais$.next(data))
        this._http.get(id).then(resp => {
            if (resp.status === 200) {
                resp.json().then((data: EngraisInterface) => {
                    this._idb.post(data)
                    Engrais$.next(data)
                })
            }
        })
    }

    post = (): Promise<EngraisInterface['id'] | null> => this._http.post().then(resp => {
        if (resp.status === 200) {
            return resp.json().then((engrais: EngraisInterface) => {
                this._idb.post(engrais);
                Engrais$.next(engrais)
                return engrais.id
            })
        } else {
            return null;
        }
    }).catch(() => null)

    put = (id: EngraisInterface['id'], purin: Partial<EngraisInterface>): Promise<number> => this._http.put(id, purin).then(resp => {
        if (resp.status === 200) {
            const newEngrais = { ...(Engrais$.getValue() as EngraisInterface), ...purin }
            this._idb.post(newEngrais)
            Engrais$.next(newEngrais)
            return 200
        }
        return 400
    }).catch(() => 500)

    uploadImage = async (id: EngraisInterface['id'], file: File): Promise<void> => {
        var form = new FormData()
        form.append('file', file)
        return this._http.uploadImage(id, form).then(resp => {
            if (resp.status === 200) {
                return resp.json().then((id: string) => {
                    const newEngrais = { ...(Engrais$.getValue() as EngraisInterface), imageId: id }
                    this._idb.post(newEngrais)
                    Engrais$.next(newEngrais)
                })
            }
        })
    }

    deleteImage = async (id: EngraisInterface['id']): Promise<void> => this._http.removeImage(id).then(resp => {
        if (resp.status === 204) {
            const newEngrais = { ...(Engrais$.getValue() as EngraisInterface), imageId: null }
            this._idb.post(newEngrais)
            Engrais$.next(newEngrais)
        }
    })

    delete = async (id: EngraisInterface['id']): Promise<boolean> => this._http.delete(id).then(resp => {
        if (resp.status === 204) {
            this._idb.delete(id)
            Engrais$.next(null)
            return true
        }
        return false
    })
}